import type {ReactNode} from 'react'
import {ChevronUp, ChevronDown} from 'lucide-react'
import {cn} from '@/lib/utils'
import {Icon} from '@/components/shared/Icon'

interface CollapsibleCardHeaderProps {
    open: boolean
    onToggle: () => void
    children: ReactNode
    className?: string
    'data-testid'?: string
}

/**
 * Clickable card-top strip used to collapse/expand nested content.
 * Renders a full-width button with the children slot on the left and a
 * chevron on the right. Only the top corners are rounded so it sits
 * flush against a <Card> container.
 */
export function CollapsibleCardHeader({
    open,
    onToggle,
    children,
    className,
    'data-testid': testId,
}: CollapsibleCardHeaderProps) {
    return (
        <button
            type="button"
            onClick={onToggle}
            data-testid={testId}
            className={cn(
                'w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-muted/30 transition-colors rounded-t-md',
                className,
            )}
        >
            {children}
            <Icon icon={open ? ChevronUp : ChevronDown} size="sm" muted/>
        </button>
    )
}
